import styled from "styled-components";
import { type WidthProps, width } from "styled-system";
import { theme } from "../theme/lexusTheme";
import { bodyStyle, type TextStyleType } from "../globals/Type";
import { getBreakpoint } from "../../../../themes/common";

export const RATING_WIDTH = 120;

export const Number = styled.span<TextStyleType>`
    display: none;
    margin-left: ${theme.space[1]}px;
    color: ${theme.colors.midnight};
    ${bodyStyle};

    @media ${getBreakpoint("up", "md")} {
        display: inline-block;
    }

    html[dir="rtl"] & {
        margin-left: 0;
        margin-right: ${theme.space[1]}px;
    }
`;

export const StarRating = styled.div`
    position: relative;
`;

export const Stars = styled.div`
    width: ${RATING_WIDTH}px;
    opacity: 1;
`;

export const StarsScore = styled.div<WidthProps>`
    position: absolute;
    top: 0;
    left: 0;
    max-width: ${RATING_WIDTH}px;
    overflow: hidden;
    ${width};

    div {
        white-space: nowrap;
    }

    html[dir="rtl"] & {
        left: auto;
        right: 0;
    }
`;

export const Review = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;
    color: ${theme.colors.midnight};
`;
